/* eslint-disable import/prefer-default-export */
const sdkApi = require('./api');

module.exports = { sdkApi };
